module.exports = __webpack_public_path__ + "static/media/13.1e9c8918.jpg";